/**
 * Команда на главной — те же ячейки, что на Contact.
 */

import TeamCards from "../components/TeamCards/TeamCards";
import "./HomeTeam.css";

function HomeTeam() {
    return (
        <div className="home-team">
            <TeamCards />
        </div>
    );
}

export default HomeTeam;
// pages/HomeTeam.js
